import BasicLayout from "@container/layout/basic";
import { LoginForm } from "@container/login-form";
import { useCompanySubdomain } from "@context/subdomain_context";

export default function LoginPage() {
  const [isLoadingCompanyInfo, companyInfo] = useCompanySubdomain()
  return (
    <BasicLayout showFooter={false}>
      <div className="w-full max-w-md mx-auto px-4 -mt-20">
        <LoginForm />
      </div>
    </BasicLayout>
  );
}
